import React, { useMemo, useState, useEffect } from "react";
import { Tabs, Input, Typography, Select, Row, Col, Button } from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";

import SearchImg from "@/assets/images/search.png";
import CardDetail from "../cardDetail";
import useBaseRequest from "@/hooks/useBaseRequest";
import {
  getcategary,
  getcategaryList,
  getZntSearch,
  getDepartmentData,
} from "@/api/index";
import { isMobile } from "@/utils/public";
import "../index.less";

function ZdSearch(props) {
  const { onClick } = props;
  const [activeKey, setActiveKey] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [inputCache, setInputCache] = useState("");
  const [searchRes, setSearchRes] = useState([]);
  const [selectName, setSelectName] = useState("");
  const { data: initCate, loading: loading2 } = useBaseRequest(getcategary, {
    // manual: true,
  });
  const [departments, setDepartments] = useState([]);
  const [selectDep, setSelectDep] = useState(undefined);
  const isMob = isMobile();
  const [refreshData, setRefreshData] = useState("");

  const scRefresh = () => {
    setRefreshData(Math.random());
  };
  const {
    data: searchData,
    runAsync: runSearch,
    loading: searchLoading,
  } = useBaseRequest(
    () =>
      getZntSearch({
        name: inputValue,
        department: selectDep ? selectDep : "",
      }),
    {
      manual: true,
      onSuccess(res) {
        if (!inputValue && !selectDep) {
          setSearchRes(null);
        } else {
          setSearchRes(res);
          setInputCache(inputValue);
        }
      },
    }
  );

  useEffect(() => {
    if (inputValue || selectDep) {
      runSearch({
        name: inputValue,
        department: selectDep,
      });
    }else{
      runSearch({
        name:"",
        department:""
      })
    }
  }, [inputValue, selectDep,refreshData]);

  const {
    data: initCateList,
    loading,
    refresh,
  } = useBaseRequest(() => getcategaryList(activeKey), {
    // manual: true,
    refreshDeps: [activeKey, refreshData],
  });

  useEffect(() => {
    runGetDepartment();
  }, []);

  const { runAsync: runGetDepartment } = useBaseRequest(
    () => getDepartmentData(),
    {
      manual: true,
      onSuccess(res) {
        console.log(res, "这是部门数据");
        const data = res?.data;
        const arr = [];

        const uniqueData = Array.from(
          new Map(
            data.map((item) => [`${item.name}-${item.id}`, item])
          ).values()
        );
        uniqueData.map((item) => {
          arr.push({
            label: item.name,
            value: item.id,
          });
        });

        setDepartments(arr);
      },
    }
  );

  const Items = useMemo(() => {
    const cateList = [{ name: "全部", id: "0" }, ...(initCate?.data ?? [])];
    // console.log(cateList)
    const cate = cateList?.map((item) => {
      return {
        title: item.name,
        key: item.id + "",
        children:
          activeKey === item.id + ""
            ? initCateList?.data?.map((jtem) => {
                // console.log(jtem, "多智能体搜索当中的")
                return {
                  label: jtem.name,
                  icon: jtem?.icon,
                  summary: jtem?.summary,
                  key: jtem.id + "",
                  outerznt: jtem.outerznt,
                  outerurl: jtem.outerurl,
                  alloweddevice: jtem.alloweddevice,
                  outOpen: jtem.outOpen,
                  owner: jtem.owner,
                  favoriteNum: jtem.favoriteNum,
                  favorite: jtem.favorite,
                  qaNum: jtem.qaNum,
                  zntId: jtem.id,
                };
              })
            : [],
      };
    });
    // console.log(cate);
    return cate;
  }, [initCateList, initCate, activeKey]);
  console.log(searchRes);
  return (
    <>
      <div className={`${isMob ? "m-zdSearchContent" : "zdSearchContent"}`}>
        <div className="content">
          {isMob ? (
            <>
              <div className="m-search">
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Select
                      options={departments}
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="全部部门"
                      onChange={(val) => {
                        console.log(val);
                        setSelectDep(val);
                        // runSearch({
                        //     name: inputValue,
                        //     department: val,
                        //   });
                      }}
                    />
                  </Col>
                  <Col span={24}>
                    <Input
                      value={inputValue}
                      onChange={(e) => {
                        setInputValue(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          runSearch({
                            name: inputValue,
                            department: selectDep || "",
                          });
                        }
                      }}
                      suffix={
                        <SearchOutlined
                          style={{ fontSize: 16, color: "#1677ff" }}
                        />
                      }
                      placeholder="搜索智能体"
                    />
                  </Col>
                  <Col span={24}>
                    <Button
                      type="primary"
                      onClick={() => {
                        runSearch({
                          name: inputValue,
                          department: selectDep || "",
                        });
                      }}
                    >
                      搜索
                    </Button>
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <div className="pcSearch">
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Select
                    style={{
                      width: "150px",
                    }}
                    options={departments}
                    allowClear
                    value={selectDep}
                    onChange={(val, row) => {
                      console.log(val, row);
                      setSelectDep(val);
                      setSelectName(row?.label);
                      // runSearch({
                      //   name: inputValue,
                      //   department: val ? val : "",
                      // });
                    }}
                    placeholder="全部部门"
                  />
                </Col>
                <Col span={12}>
                  <Input
                    value={inputValue}
                    onChange={(e) => {
                      setInputValue(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        runSearch({
                          name: inputValue,
                          department: selectDep,
                        });
                      }
                    }}
                    suffix={
                      <SearchOutlined
                        style={{ fontSize: 16, color: "#1677ff" }}
                      />
                    }
                    placeholder="搜索智能体"
                  />
                </Col>
              </Row>
            </div>
          )}

          {searchRes?.data ? (
            <>
              <Typography.Paragraph
                style={{
                  color: "#2c2c36",
                  fontSize: 18,
                  fontWeight: 500,
                  lineHeight: "32px",
                }}
              >{`与“${selectName ? `${selectName}` : ""}${
                selectName && inputCache ? "和" : ""
              }${inputCache}”相关的智能体`}</Typography.Paragraph>
              <CardDetail
                style={{ width: "100%" }}
                onClick={onClick}
                mobile={isMob}
                scRefresh={scRefresh}
                data={searchRes?.data?.map((item) => ({
                  label: item.name,
                  icon: item?.icon,
                  summary: item?.summary,
                  key: item?.id + "",
                  outerznt: item.outerznt,
                  outerurl: item.outerurl,
                  alloweddevice: item.alloweddevice,
                  outOpen: item.outOpen,
                   owner: item.owner,
                  favoriteNum: item.favoriteNum,
                  favorite: item.favorite,
                  qaNum: item.qaNum,
                  zntId: item.id,
                }))}
              />
            </>
          ) : (
            <>
              <Tabs
                style={{
                  height: isMob ? "calc(100% - 45px)" : "100%",
                }}
                type="card"
                items={Items?.map((item, index) => {
                  // console.log(item, "tabs的值")
                  return {
                    label: item?.title,
                    key: item.key,
                    children: (
                      <CardDetail
                        mobile={isMob}
                        onClick={onClick}
                        data={item?.children}
                        scRefresh={scRefresh}
                      />
                    ),
                  };
                })}
                tabBarGutter={15}
                activeKey={activeKey}
                onChange={(activeKey) => {
                  setActiveKey(activeKey + "");
                }}
                tabBarExtraContent={
                  isMob ? undefined : (
                    <div
                      style={{
                        width: "300px",
                      }}
                    ></div>
                  )
                }
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default ZdSearch;
